module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AresLoading":{"button":"Načíst údaje z ARES"}},"de":{"AresLoading":{"button":"Abrufen von Daten aus ARES"}},"sk":{"AresLoading":{"button":"Načítať údaje z ARES"}}}')
  delete Component.options._Ctor
}
